// src/components/RiskBadge.jsx
// Color-coded risk tier badge used across the app

import React from 'react';

export default function RiskBadge({ score, tier, label, size = 'md' }) {
  const colorMap = {
    high:    { bg: 'bg-red-100', text: 'text-red-700', ring: 'ring-red-200' },
    medium:  { bg: 'bg-amber-100', text: 'text-amber-700', ring: 'ring-amber-200' },
    low:     { bg: 'bg-gray-100', text: 'text-gray-600', ring: 'ring-gray-200' },
    minimal: { bg: 'bg-green-100', text: 'text-green-700', ring: 'ring-green-200' },
  };

  const sizeMap = {
    sm: 'text-xs px-2 py-0.5',
    md: 'text-xs px-2.5 py-1',
    lg: 'text-sm px-3 py-1.5',
  };

  const colors = colorMap[tier] || colorMap.low;

  return (
    <span className={`
      inline-flex items-center gap-1.5 rounded-full font-semibold ring-1
      ${colors.bg} ${colors.text} ${colors.ring} ${sizeMap[size]}
    `}>
      <span className="font-bold">{score}</span>
      <span className="opacity-75">{label}</span>
    </span>
  );
}
